import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../constants/mobile';

/**
 * Tracks whether the viewport is narrower than `breakpoint` (default: the app-wide
 * MOBILE_BREAKPOINT). Below it the shell swaps the left sidebar for a bottom tab bar
 * and the trading pages stack chart over config instead of sitting side by side.
 */
export function useIsMobile(breakpoint = MOBILE_BREAKPOINT): boolean {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState<boolean>(() => matchQuery(query)?.matches ?? false);

  useEffect(() => {
    const mql = matchQuery(query);
    if (!mql) return;
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return isMobile;
}

/** jsdom and older Safari have no matchMedia; those callers get the desktop layout. */
function matchQuery(query: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(query);
}

export default useIsMobile;
